export default {
  title: 'Mistede ordrer',
  card_title: 'E-mails om mistede ordrer',
  intro:
    'Hvis ingen accepterer en ordre inden for {{minutes}} minutter, afvises den automatisk. Alle på denne liste får så en e-mail med ordren, så nogen kan følge op.',
  default: {
    owner: 'Restaurantejer',
    partner: 'Partner',
    owner_missing: 'Restaurantejeren ({{email}}) får ikke disse e-mails.',
    partner_missing: 'Partnerens standardadresse ({{email}}) får ikke disse e-mails.',
  },
  empty: 'Ingen ville høre om mistede ordrer. Tilføj mindst én e-mail for at gemme.',
  save_error: 'E-mails kunne ikke gemmes. Tjek din forbindelse, og prøv igen.',
  load_error: 'E-mails kunne ikke indlæses. Tjek din forbindelse, og prøv igen.',
  unavailable: 'E-mails om mistede ordrer er ikke tilgængelige for denne restaurant.',
  buttons: {
    save: 'Gem',
    retry: 'Prøv igen',
  },
  toasts: {
    saved: 'E-mails om mistede ordrer er gemt',
  },
};
